module.exports = __webpack_public_path__ + "cafc395db6d13ab5771fedb3402af472.png";